module.exports = __webpack_public_path__ + "static/img/111.65750a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/111.jpg
// module id = 9MXG
// module chunks = 1